import { i18next } from '@yola/ws-sdk';
import { SLUG_PATTERN } from '../constants/slug';

const defaultBindings = [];

const createBindingSlugValidator =
  ({ bindings = defaultBindings, existingSlug = '' } = {}) =>
  (value) => {
    if (!value || !value.trim()) {
      return i18next.t('This field is required');
    }

    const trimmed = value.trim();

    if (!SLUG_PATTERN.test(trimmed)) {
      return i18next.t(
        'Variable name must start with a letter and contain only lowercase letters, digits, and underscores'
      );
    }

    const isDuplicate = bindings.some((b) => b.slug === trimmed && b.slug !== existingSlug);

    if (isDuplicate) {
      return i18next.t('This variable name is already used on this page');
    }

    return null;
  };

export default createBindingSlugValidator;
